import i18n from 'i18next';
import XHR from 'i18next-xhr-backend';


var install_path = (window.install_path ? window.install_path : '/altavailability');

if(!window.css_js_query_string) {
  window.css_js_query_string = '0';
}

i18n
  .use(XHR)
  .init({
    backend: {

      loadPath: install_path+'/locales/{{lng}}/{{ns}}.json?_='+window.css_js_query_string
    },
    fallbackLng: 'en',

    // have a common namespace used around the full app
    ns: ['common'],
    defaultNS: 'common',

    debug: false,

    interpolation: {
      escapeValue: false // not needed for react!!
    }
  });


export default i18n;